<!-- 会长简介 -->
<template>
  <div class="main_area">
    <Head />
    <Breadcrumb :crumbs="crumbs" />
    <div style="flex: 1" class="max_width">
      <div
        style="
          width: 1200px;
          box-sizing: border-box;
          box-shadow: 0 0 10px #d9e4ec;
          border-radius: 10px;
          padding: 40px;
          margin: 30px auto;
        "
      >
        <div class="xhgk_title_box">
          <div class="xhgk_title">广东省民族管弦乐学会历任会长介绍</div>
        </div>
        <div style="margin-top: 10px; font-size: 14px">President Introduction</div>
        <div style="margin-top: 40px; overflow: hidden">
          <div class="hzjs_data_item" v-for="(item, i) in huizhangdata" :key="i">
            <!-- 图片动态左右浮动 -->
            <el-image
              :style="{ float: i % 2 == 0 ? 'left' : 'right' }"
              :src="item.img"
              fit="contain"
            ></el-image>
            <div>
              <div class="hzjs_data_item_title">
                <span>
                  <h3>{{ item.name }}</h3>
                  <span>{{ item.renqi }}</span>
                </span>
              </div>
              <div
                v-for="(text, j) in item.text_data"
                :key="j"
                class="hzjs_data_item_text"
              >
                {{ text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightFixBox />
    <Footer />
  </div>
</template>

<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";
import RightFixBox from "@/components/RightFixBox.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  data() {
    return {
      crumbs: [{ text: "首页", to: { path: "/" } }, { text: "历任会长介绍" }],
      content: "",
      huizhangdata: [],
      // {
      //   img: require('@/assets/president_img1.png'),
      //   name: '彭修文',
      //   renqi: '首任会长',
      //   text_data: ['彭修文（1931~1996），中国现代民族管弦乐一代宗师，杰出的作曲家、指挥家，广东省民族管弦乐学会首任会长，原中国广播艺术团艺术指导，中国广播民族乐团首席指挥。', '彭修文先生世代书香，天资颖悟，博文强记。在学生时代的音乐活动中，才华初露既被时人推许。五十年代初与张晋德先生等组建了中国第一个职业民族乐团——中国广播民族乐团并历任指挥，作曲。 1957年率团参加莫斯科第六届世界青年联欢节，获金质奖章，其音乐艺术才华令人赞叹。', '彭修文先生治学严谨，训练乐团有方有素，形成了合作默契、音色绚烂、意蕴深邃，独树一帜的艺术风格。彭修文先生发起并指导的中国广播民族乐团人才辈出，称雄乐坛，历久不衰，几十年来为社会播演了两千多首古今中外风格迥异的乐曲。尤以彭修文先生创作改编的四百多部作品最为流传、影响深远，如《将军令》《花好月圆》《彩云追月》《瑶族舞曲》《月儿高》《乱云飞》《丰收锣鼓》，交响诗《流水操》、交响诗《怀》、《灵山梵呗》、幻想曲《秦·兵马俑》、套曲《十二月》、第一交响乐《金陵》等，以及外国民族民间音乐《达姆达姆》（阿尔及利亚）、《美丽的梭罗河》（印度尼西亚）、《相马盆呗》（日本）、《肯塔基故乡与苏珊娜》（美国）等，西方古典大师的经典作品，如贝多芬《雅典的废墟》、比才《卡门》组曲、德彪西《云》、斯特拉文斯基《火鸟》、莫索尔斯基《图画展览会》、莫扎特《弦乐小夜曲》等等，均受到中外听众、专家、学者、演奏家的热烈欢迎和高度赞赏。充分体现其深厚的中国传统音乐文化根基和高超的乐队写作及融贯中西的艺术修养。', '几十年来，彭修文及中国广播民族乐团足迹遍及世界几十个国家和地区，为弘扬、传播中国民族文化艺术，促进各国人民的友谊和文化交流做出巨大的贡，业绩卓然，口碑载道。'],
      // }
    };
  },

  components: {
    Head,
    Footer,
    RightFixBox,
    Breadcrumb,
  },

  computed: {},

  mounted() {
    this.gethuizhang();
  },

  methods: {
    // TODO 获取会长数据
    gethuizhang() {
      const that = this;
      this.$axios
        .post("/huizhang/getlist", {
          page: 1,
          size: 5,
          is_del: 0,
        })
        .then((res) => {
          console.log("获取会长列表返回", res);
          if (res.code === 200) {
            for (let i = res.data.data.length - 1; i >= 0; i -= 1) {
              res.data.data[i].text_data = res.data.data[i].info.split("\n");
              console.log(res.data.data[i]);
            }
            that.huizhangdata = res.data.data;
            console.log(that.huizhangdata);
          }
          //  else {
          //   that.booklist = [];
          // }
        })
        .catch((err) => {
          console.log("请求失败", err);
        });
    },
  },
};
</script>
<style scoped></style>
